export const SEVERITY_DANGER = 'danger' as const
export const SEVERITY_WARNING = 'warning' as const
